class BfvFormular {
  constructor(options = {}) {
    this.$root = options.element;
    this.$carpoolRadioButtons = this.$root.querySelectorAll('input[name="carpool__radio-button"]');
    this.$carpoolGroupNumberInput = this.$root.querySelector('input[name="carpool__group-number-input"]');
    this.apiUrl = this.$root.getAttribute('data-api-url');
  }

  init() {
    this.bindEvents();
    this.$carpoolGroupNumberInput.disabled = true;
  }

  bindEvents() {
    this.$carpoolRadioButtons.forEach((radioButton) => {
      radioButton.addEventListener('click', () => {
        this.$carpoolGroupNumberInput.disabled = false;
        if (radioButton.value === 'teilnehmen') {
          this.$carpoolGroupNumberInput.value = '';
        } else if (radioButton.value === 'erstellen') {
          this.getGroupNumber();
        }
      });
    });
  }

  getGroupNumber() {
    window.divae.restApi
      .loadData(this.apiUrl)
      .then((response) => {
        this.$carpoolGroupNumberInput.value = response.groupNumberId;
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

export default BfvFormular;
